import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./Login.scss";
import loginImage from "../../assets/images/login-image.png";
import logo from "../../assets/images/logo.svg";

import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { useForm, Controller } from "react-hook-form";

import { commonPostApi, commonGetApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { userProfile } from "../../redux/commonSlice";
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
import Loader from '../../components/common/loader';
import { Dialog } from "primereact/dialog";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, FEATURE_MSG } from "../../constants/toast";
import { DevTool } from "@hookform/devtools";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      remember_me: false,
    },
  });

  const handleLoginSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const response = await commonPostApi(API_ENDPOINTS.LOGIN, {
        email: formData.username,
        password: formData.password,
        remember_me: formData.remember_me,
      });

      if (response?.data) {
        localStorage.setItem(
          "organization_id",
          response.data.user.initial_organization_id
        );
        localStorage.setItem(
          "camp_id",
          response.data.user.initial_camp_details_id
        );

        try {
          const userProfileResponse = await commonGetApi(API_ENDPOINTS.USER_PROFILE);
          if (userProfileResponse?.data?.data) {
            dispatch(userProfile(userProfileResponse.data.data));
          }
        } catch (profileError) {
          console.error("Failed to fetch user profile:", profileError);
        }

        showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.AUTH.LOGIN_SUCCESS);
        reset();
        navigate(response.data.user.is_donor ? "/reports/donor" : "/dashboard");
      } else {
        const errorMessage =
          response?.response?.data?.message ||
          response?.response?.data ||
          FEATURE_MSG.AUTH.LOGIN_ERROR;
        showToast(TOAST_TYPE.ERROR, errorMessage);
      }
    } catch (error) {
      console.error("Login error:", error);
      showToast(TOAST_TYPE.ERROR, FEATURE_MSG.AUTH.LOGIN_ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const navigateToForgotPassword = () => {
    navigate("/forgotpassword");
  };

  return (
    <div>
      <div className="Login__main-container">
        <div className="Login__image-sec">
          <img src={loginImage} alt="Login Background" />
        </div>
        <div className="Login__right-section">
          <div className="Login__right-log-sec">
            <img src={logo} alt="Company Logo" />
          </div>
          <div className="Login__right-form-sec">
            <div className="Login__right-header-sec">
              <p className="heading">Welcome to Vital Impact</p>
              <p className="sub-heading">
                Please sign-in to your account to begin
              </p>
            </div>
            <form onSubmit={handleSubmit(handleLoginSubmit)}>
              <div className="Login__form-container">
                <div className="Login__form-control">
                  <InputPrimaryComponents
                    type="text"
                    label="Email or Username"
                    errors={errors}
                    control={control}
                    name="username"
                    rules={{ required: "Username is required" }}
                    paddingStyle={true}
                    autoFocus={true}
                  />
                </div>
                <div className="Login__form-control">
                  <InputPrimaryComponents
                    type="password"
                    label="Password"
                    errors={errors}
                    control={control}
                    name="password"
                    rules={{ required: "Password is required" }}
                    paddingStyle={true}
                  />
                </div>
                <div className="Login__remember-sec">
                  <div className="remember-left-sec">
                    <Controller
                      control={control}
                      name="remember_me"
                      render={({ field }) => (
                        <Checkbox
                          inputId="remember_me"
                          control={control}
                          onChange={(e) => field.onChange(e.checked)}
                          checked={field.value}
                        ></Checkbox>
                      )}
                    />
                    <label htmlFor="remember_me" className="remember-label">
                      Remember Me
                    </label>
                  </div>
                  <div className="remember-right-sec">
                    <Button
                      type="button"
                      link
                      onClick={navigateToForgotPassword}
                    >
                      <span className="p-button-label">Forgot Password?</span>
                    </Button>
                  </div>
                </div>
                <div className="Login__login-btn">
                  <Button type="submit" disabled={isLoading}>
                    <div className="button-actions">
                      {isLoading ? (
                        <>
                          <Loader />
                          <span
                            className="p-button-label p-c"
                            data-pc-section="label"
                          >
                            Processing
                          </span>
                        </>
                      ) : (
                        <span className="p-button-label">Login</span>
                      )}
                    </div>
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Dialog
        visible={isDialogVisible}
        onHide={() => setIsDialogVisible(false)}
        style={{ width: "40rem" }}
        header={<span>Information</span>}
        footer={
          <Button
            label="OK"
            icon="pi pi-check"
            onClick={() => setIsDialogVisible(false)}
            autoFocus
          />
        }
      >
        Kindly contact the Administrator
      </Dialog>
      <DevTool control={control} />
    </div>
  );
};

export default Login;
